import { render, staticRenderFns } from "./courseBookList.vue?vue&type=template&id=5c5c1871&"
import script from "./courseBookList.vue?vue&type=script&lang=ts&"
export * from "./courseBookList.vue?vue&type=script&lang=ts&"
import style0 from "./courseBookList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports